import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

import { readStoredSettings, type AppearanceSettings } from './settingsStorage';

export type SettingsState = AppearanceSettings;

const initialState: SettingsState = readStoredSettings();

/**
 * Guarded-partial on purpose: the reducer writes only the fields present in the payload,
 * so `settings({ language: 'ta' })` from the language picker can never blank the brand
 * or drop the user back into light mode.
 */
const settingsSlice = createSlice({
  name: 'settings',
  initialState,
  reducers: {
    settings: (state, action: PayloadAction<Partial<SettingsState>>) => {
      const next = action.payload;
      if (next.theme !== undefined) state.theme = next.theme;
      if (next.colorMode !== undefined) state.colorMode = next.colorMode;
      if (next.language !== undefined) state.language = next.language;
      if (next.fontSize !== undefined) state.fontSize = next.fontSize;
    },
    resetSettings: () => readStoredSettings()
  }
});

export const { settings, resetSettings } = settingsSlice.actions;
export const settingsReducer = settingsSlice.reducer;
